import { render } from "./ScreenLockPage.vue?vue&type=template&id=93e9b070"
import script from "./ScreenLockPage.vue?vue&type=script&lang=js"
export * from "./ScreenLockPage.vue?vue&type=script&lang=js"

import "./ScreenLockPage.vue?vue&type=style&index=0&id=93e9b070&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__